<template>
  <div class="login-form-wrapper">
    <div class="arrow-container-3">
      <a @click="goToBack"
        ><img src="@/assets/timeslot-images/left-arrow.svg"
      /></a>
    </div>
    <div class="div-block-20">
      <div class="div-block login">
        <div class="text-block">Set Password 🔐</div>
        <div
          class="text-block-3"
          style="font-family: 'Galano grotesque-Medium', sans-serif;"
        >
          Enter your desired password to your account
        </div>
      </div>
    </div>
    <!--    matches:/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/-->
    <div class="div-block">
      <FormulateForm>
        <FormulateInput
          type="password"
          name="password"
          placeholder="Password"
          validation="bail|required"
          validation-name="Password"
          v-model="password"
          error-behavior="value"
        />
        <FormulateInput
          type="password"
          name="password_confirm"
          validation="required|confirm"
          placeholder="Confirm password"
          validation-name="Password Confirmation"
          v-model="passwordConfirm"
        />
        <FormulateInput type="submit" label="Continue" @click="savePassword" />
      </FormulateForm>
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

export default {
  name: "TimeslotPasswordResetForm",
  data() {
    return {
      password: "",
      passwordConfirm: ""
    };
  },
  methods: {
    goToBack() {
      RouterUtils.changeRouteUrlTo("/reset-password");
    },
    savePassword() {
      if (this.password === this.passwordConfirm) {
        StoreUtils.commit("auth/setResetPassword", this.password);
        StoreUtils.commit("auth/setResetPasswordConfirm", this.passwordConfirm);
        RouterUtils.changeRouteUrlTo("/confirm-email");
      }
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    }
  }
};
</script>

<style scoped></style>
